import PaymentMethodsApiService from '@package/core/src/payment/PaymentMethod/PaymentMethodsApiServer';
import PaymentMethodsInteractor from '@package/core/src/payment/PaymentMethod/PaymentMethodsInteractor';
import { PaymentMethod } from '@package/core/src/payment/PaymentMethod/types';
import { PaymentMethodsType } from '@package/core/src/payment/types';
import { apiClient } from '../services';
import { useStrictQuery } from '../useCustomQuery';

import { PAYMENT_METHOD_PRIORITY, PAYMENT_METHODS_QUERY_KEY, PaymentMethods } from './types';

const paymentMethodsService = new PaymentMethodsApiService(apiClient);
const paymentMethodsInteractor = new PaymentMethodsInteractor(paymentMethodsService);

export default function usePaymentMethods({
  affirmEnabled,
  sezzleEnabled,
  applePayEnabled,
  fetchPaymentMethods = true,
}: PaymentMethods) {
  const {
    data: methods,
    isLoading,
    isFetchedAfterMount: isPaymentFetched,
  } = useStrictQuery(
    [PAYMENT_METHODS_QUERY_KEY],
    async () => {
      const res = await paymentMethodsInteractor.getPaymentMethods();
      return res.data;
    },
    { enabled: fetchPaymentMethods },
  );
  const paymentMethods = methods
    ?.filter((method: PaymentMethod) => (method.paymentType !== PaymentMethodsType.Affirm ? true : affirmEnabled))
    ?.filter((method: PaymentMethod) => (method.paymentType !== PaymentMethodsType.Sezzle ? true : sezzleEnabled))
    ?.filter((method: PaymentMethod) => (method.paymentType !== PaymentMethodsType.ApplePay ? true : applePayEnabled))
    .map((method: PaymentMethod): PaymentMethod => {
      switch (method.paymentType) {
        case PaymentMethodsType.PayPal:
          method.label = 'Pay with';
          method.imageLink = '/marketplace-static/images/PayPal.svg';
          break;
        case PaymentMethodsType.Affirm:
          method.label = 'Pay over time with';
          method.imageLink = '/marketplace-static/images/Affirm.svg';
          break;
        case PaymentMethodsType.Sezzle:
          method.label = 'Pay over time with';
          method.imageLink = '/marketplace-static/images/sezzle-logo-vector.svg';
          break;
        case PaymentMethodsType.Check:
          method.label = 'Check & Money Order';
          break;
        case PaymentMethodsType.WireTransfer:
          method.label = 'Pay with Wire Transfer';
          break;
        case PaymentMethodsType.GiftCard:
          method.label = 'Pay with GC';
          break;
        case PaymentMethodsType.ApplePay:
          method.label = 'Pay with';
          method.imageLink = '/marketplace-static/images/apple-pay.svg';
          break;
        default:
          break;
      }
      return method;
    })
    .sort((a: PaymentMethod, b: PaymentMethod) => {
      const priorityA = PAYMENT_METHOD_PRIORITY[a.paymentType] || 999;
      const priorityB = PAYMENT_METHOD_PRIORITY[b.paymentType] || 999;
      return priorityA - priorityB;
    });

  return { paymentMethods, isLoading, isPaymentFetched };
}
